<div class="app-container">
  <page-header [icon]="'far-hand-holding-usd'" [title]="'vats'">
    <ng-container class="header-button">
      @if (canCreate()) {
        <btn
          [routerLink]="['/vat']"
          [icon]="'far-plus'"
          [label]="'vats.create'"
          [title]="'vats.create' | translate"
          [classes]="['btn-first', 'float-right']"
          [dataCyAttribute]="'go-vat'"
        ></btn>
      }
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [totalItems]="totalItems()"
      [entity]="'vats'"
      (onSubmit)="queryVats.refetch()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
    >
      <form-row-input
        [label]="'vats.name'"
        [icon]="'far-list'"
        [model]="filters().name"
        (modelChange)="setFilterName($event)"
        (keydown.enter)="queryVats.refetch()"
        [dataCyAttribute]="'vat-name-filter'"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [listName]="'vats'"
      [query]="queryVats"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
